import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { useModal } from '@lwtears/lwt-common-frontend/lib/Modal';
import { Card, List, ListItem } from '@mui/material';
import Typography from '@mui/material/Typography';
import BaseModalTitle from 'components/common/BaseModalTitle';
import { Remediation } from 'types';

const t = (key) => translate('ui', key);

const RecommendationsModal = (props: { remediations: Remediation[] }) => {
  const [, { closeModal }] = useModal();

  return (
    <Card>
      <BaseModalTitle text={t('class.recommendations')} onClose={closeModal} />
      <List>
        {props.remediations.map((remediation) => {
          return (
            <ListItem key={remediation.id}>
              <Typography
                dangerouslySetInnerHTML={{
                  __html: remediation.text.replace(
                    /\*{2}([^*]+)\*{2}/g,
                    "<span style='font-family: HWT Futura Semi Bold'>$1</span>"
                  ),
                }}
              />
            </ListItem>
          );
        })}
      </List>
    </Card>
  );
};

export default RecommendationsModal;
